export default "__VITE_ASSET__apqFHC9m__"